import { render, staticRenderFns } from "./StaffUsers.vue?vue&type=template&id=54b59f80&scoped=true&"
import script from "./StaffUsers.vue?vue&type=script&lang=js&"
export * from "./StaffUsers.vue?vue&type=script&lang=js&"
import style0 from "./StaffUsers.vue?vue&type=style&index=0&id=54b59f80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b59f80",
  null
  
)

export default component.exports